import Document from "../components/v2/Document";
import Section from "../components/section/Section";
import Title from "../components/Title";

const NotFoundPage = () => (
	<Document title="Page not found" accentureAccessible={true}>
		<Section className="py-6 py-md-20">
			<div className="row">
				<div className="col text-center">
					<Title>Page could not be found</Title>
					<p className="mt-5">
						No worries, you can return to{" "}
						<a href="/" className="link" style={{ fontSize: 15 }}>
							our homepage
						</a>
						.
					</p>
				</div>
			</div>
		</Section>
	</Document>
);

export default NotFoundPage;
